// mixins.js
export default {
    methods: {
      replaceText(text) {
        // const replacements = [
        //   "确定负面",
        //   "疑似负面",
        //   "确定负面(高敏感)",
        //   "确定负面(敏感)"
        // ];
        // if (replacements.includes(text)) {
        //   return "敏感文章";
        // }
        return text;
      }
    }
  };
  